// extracted by mini-css-extract-plugin
export default {"pic":"AvatarPic_pic__0hLOj","size-medium":"AvatarPic_size-medium__FwqvL","size-big":"AvatarPic_size-big__72Tf-","size-small":"AvatarPic_size-small__5M1ab"};